/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 全局搜索旗舰店
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export class ShopsGlobalSearchParams {
  constructor(
    public keyword: string,
    public page: number,
    public size: number
  ) {}
}

export default async function (
  params: ShopsGlobalSearchParams,
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: good.Page<good.TheaterShopSearchDto>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/good/shops/global/search`,

    params,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
